"use client";
import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import i18n from "@/i18n";
import { Trans } from "react-i18next";

const StatsContainer = styled.section`
  background-color: white;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

const StatsContent = styled.div`
  position: relative;
  display: flex;
  min-height: 552px;
  width: 100%;
  max-width: 900px;
  flex-direction: row;
  align-items: start;

  @media (max-width: 991px) {
    max-width: 100%;
    padding: 100px 20px;
  }
`;

const StatsInnerContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 1150px;
  height: 500px;
  
  &.left-stats-inner-container {
    flex: 1;
  }
  >.stats-top-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 70%;
    min-height: 70%;
  }
  >.stats-bottom-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 30%;
    min-height: 30%;
    margin-top: 60px;
  }
`;

const MainDescription = styled.p`
  text-align: center;
  color: rgba(0, 0, 0, 1);
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.4px;
  text-align: left;
  white-space: pre-wrap;

  >.frame-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;  

    &.jp {
      .highlight {
        font-size: 30px;
      }
    }
    >img {
      width: 40px;
      height: 40px;
    }
    .highlight {
      color: rgba(0, 189, 203, 1);
      font-size: 34px;
      font-weight: 800;
      
    }
  }
`;


const SubDescription = styled.p`
  text-align: left;
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: -0.4px;
    white-space: pre-wrap;

  >.sub-des-text-container {
    margin-bottom: 12px;
    text-align: left;
    color: rgba(0, 0, 0, 1);
    font-size: 18px;
    font-weight: 600;
    line-height: 30px;
    letter-spacing: -0.4px;
    white-space: pre-wrap;
    word-break: keep-all;
    padding-right: 50px;

    &.en {
      padding-right: 20px;
    }

    &.jp {
      padding-right: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }

    strong {
      font-weight: 800;
    }

    .highlight {
      color: rgba(0, 189, 203, 1);
      font-size: 20px;
      line-height: 36px;
      font-weight: 700;
    }
  }
`;

const StatContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const StatLabel = styled.div`
  color: #525252;
  font-size: 20px;
  font-weight: 700;
  margin-left: 5px;
`;

const StatValue = styled.div`
  font-size: 110px;
  letter-spacing: -2.56px;
  max-width: 100%;
  color: black;
  font-weight: 700;
  margin: 0 auto;
`;

export default function StatisticsSection() {
  const lang = useSelector(state => state.langStore.lang);
  return (
    <StatsContainer>
      <StatsContent>
        <StatsInnerContainer className="left-stats-inner-container">
          <div className="stats-top-area">
            <MainDescription>
              <span className={`frame-container ${lang}`}>
                <span>{i18n.t("web.pc.landing.2025.statistics.left.description.1")}</span>
                <img src="https://front.videomonster.com/images-u6yd72dy/web/v2/landing2025/frame-left.svg" alt="left" />
                <span className="highlight">{i18n.t("web.pc.landing.2025.statistics.left.description.2")}</span>
                <img src="https://front.videomonster.com/images-u6yd72dy/web/v2/landing2025/frame-right.svg" alt="right" />
              </span>
              <br />
              {i18n.t("web.pc.landing.2025.statistics.left.description.3")}
            </MainDescription>
          </div>
          <div className="stats-bottom-area"> 
            <StatContainer>
              <StatLabel>{i18n.t("web.pc.landing.2025.statistics.count.account.1")}</StatLabel>
              <StatValue>{i18n.t("web.pc.landing.2025.statistics.count.account.2")}</StatValue>
            </StatContainer>
          </div>
        </StatsInnerContainer>
        <StatsInnerContainer>
          <div className="stats-top-area">
            <SubDescription>
              <div className={`sub-des-text-container ${lang}`}>
                <Trans i18nKey="web.pc.landing.2025.statistics.right.description.1">
                  <strong />
                </Trans>
              </div>
              <div className={`sub-des-text-container ${lang}`}>
                <Trans i18nKey="web.pc.landing.2025.statistics.right.description.2">
                  <strong />
                </Trans>
              </div>
              <div className={`sub-des-text-container ${lang}`}>
                <Trans 
                  i18nKey="web.pc.landing.2025.statistics.right.description.3"
                  components={[<strong />, <span className="highlight" />]}
                />
              </div>
            </SubDescription>
          </div>
          <div className="stats-bottom-area"> 
            <StatContainer>
              <StatLabel>{i18n.t("web.pc.landing.2025.statistics.count.video.1")}</StatLabel>
              <StatValue>{i18n.t("web.pc.landing.2025.statistics.count.video.2")}</StatValue>
            </StatContainer>
          </div>
        </StatsInnerContainer>
      </StatsContent>
    </StatsContainer>
  );
}
